module.exports = __webpack_public_path__ + "static/media/sc13.21.8f8cd1db.mp4";